import { render, staticRenderFns } from "./Embarrassment.vue?vue&type=template&id=204bfa7d&"
import script from "./Embarrassment.vue?vue&type=script&lang=js&"
export * from "./Embarrassment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports